/* AFS7 - scroll- en afhaakmeting voor de HELE webshop.
   Draait op elke pagina via sections/afs7-assets.liquid in footer-group.

   Waarom het zo is opgebouwd
   --------------------------
   GA4 staat op deze winkel als Custom Pixel (Settings > Customer events).
   Een Web Pixel draait in een sandbox en kan de DOM NIET lezen, dus scrollen
   kan daar niet gemeten worden. Themacode kan dat wel, maar heeft geen gtag.
   De brug is Shopify's eigen custom-event kanaal: wij publiceren hier, de
   pixel abonneert zich erop en stuurt het door naar GA4.

   Ronde 2, 2026-09-22: de sectienaam deugde niet.
   -----------------------------------------------
   De naam werd afgeleid uit de CLASS van het element, en de omhulsels die
   Shopify om elke sectie zet heten allemaal gewoon "shopify-section". In GA4
   stond daardoor bij vrijwel elk afhaakpunt de waarde "shopify-section", wat
   niets zegt. Erger nog: die omhulsels bevatten de echte AFS7-secties, dus het
   nietszeggende omhulsel overschreef telkens de goede naam die er al stond.

   Nu: eerst het eigen data-afs7-section attribuut ("afs7-bestsellers"), anders
   afgeleid uit het element-id, waarbij het Shopify-voorvoegsel en het
   template-deel eraf gaan zodat er "afs7_press" overblijft in plaats van
   "shopify-section-template--23591131087086__afs7_press". En een omhulsel dat
   zelf een AFS7-sectie bevat wordt overgeslagen, zodat elke sectie een keer
   telt onder een naam.

   Ronde 3, 2026-09-25: hoge secties werden nooit geteld.
   ------------------------------------------------------
   De waarnemer stond op threshold 0.5, wat betekent: tel een sectie pas als de
   HELFT ervan in beeld staat. Een sectie die hoger is dan twee schermen haalt
   dat nooit, hoe lang je er ook naar kijkt. Precies de twee belangrijkste
   secties van de winkel zijn zo hoog: het productraster op de collectiepagina
   en het koopblok op de productpagina.

   Gemeten over 23 t/m 25 september, voor deze reparatie:
     collectiepagina  header 352 gezien, deal 347, maar "main" (het raster) 39
     productpagina    header 324 gezien, guar 257, maar "main" (het koopblok) 27

   Het gevolg was erger dan een ontbrekend getal. Omdat die hoge secties nooit
   vuurden, bleef last_section hangen op de laatste KLEINE sectie erboven. In
   GA4 stond daardoor 454 van de 686 uitstappen op de collectiepagina op "deal",
   de gele balk bovenaan, terwijl die mensen allang in het raster scrolden. En
   op de productpagina stond "header" op gemiddeld 438 seconden, wat een balk
   van 40 pixels natuurlijk nooit zelf verdient.

   Nu: threshold 0 met een rootMargin die de bovenste en onderste 20% van het
   scherm wegsnijdt. Een sectie telt zodra hij de middelste 60% van het scherm
   raakt. Dat werkt voor een balk van 40 pixels en voor een raster van 4000
   pixels even goed, en last_section wijst voortaan naar wat de bezoeker
   werkelijk in het midden van zijn scherm had staan toen hij wegging.

   LET OP bij het vergelijken: data van voor deze reparatie telt hoge secties
   niet mee en legt afhaakpunten te hoog op de pagina. Cijfers van voor
   25 september zijn niet vergelijkbaar met die erna. */
(function () {
  'use strict';
  if (window.__afs7Track) return;
  window.__afs7Track = true;

  var page = (window.__afs7Page || document.body.getAttribute('data-afs7-page') || 'other');
  var start = Date.now();
  var maxPct = 0;
  var lastSection = '';
  var seen = {};
  var marks = [25, 50, 75, 90];
  var fired = {};

  function emit(name, payload) {
    payload = payload || {};
    payload.page_kind = page;
    payload.path = location.pathname;
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, payload); } catch (e) {}
  }

  /* Een naam waar je in een rapport iets aan hebt. */
  function sectionName(el) {
    var name = el.getAttribute('data-afs7-section');
    if (name) return name;
    var id = el.id || '';
    if (id.indexOf('shopify-section-') === 0) {
      name = id.slice(16);
      var u = name.indexOf('__');
      if (u > -1) name = name.slice(u + 2);
      if (name) return name;
    }
    return 'section';
  }

  function pct() {
    var h = document.documentElement;
    var scrollable = (h.scrollHeight - window.innerHeight);
    if (scrollable <= 0) return 100;
    return Math.min(100, Math.round(((window.pageYOffset || h.scrollTop) / scrollable) * 100));
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var p = pct();
      if (p > maxPct) maxPct = p;
      for (var i = 0; i < marks.length; i++) {
        var m = marks[i];
        if (maxPct >= m && !fired[m]) {
          fired[m] = true;
          emit('afs7_scroll_depth', { percent: m });
        }
      }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Welke sectie is echt gezien, en welke was de laatste voor het vertrek.
     Dat laatste is het afhaakpunt waar we op willen sturen. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var name = sectionName(en.target);
        lastSection = name;
        if (seen[name]) return;
        seen[name] = true;
        emit('afs7_section_view', { section: name });
      });
    }, {
      /* Ronde 3. Niet "de helft van de sectie in beeld" maar "de sectie raakt
         het midden van het scherm". Een percentage van de SECTIE is onbruikbaar
         zodra een sectie hoger is dan het scherm; een percentage van het SCHERM
         werkt bij elke hoogte. */
      rootMargin: '-20% 0px -20% 0px',
      threshold: 0
    });

    var nodes = document.querySelectorAll('[data-afs7-section], .shopify-section');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      /* Een Shopify-omhulsel dat zelf een AFS7-sectie bevat telt niet mee: dan
         zou dezelfde sectie twee keer meten, onder twee namen, en zou het
         omhulsel de goede naam overschrijven. */
      if (!n.hasAttribute('data-afs7-section') && n.querySelector('[data-afs7-section]')) continue;
      io.observe(n);
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a,button');
    if (!a) return;
    var label = (a.getAttribute('data-afs7-cta') || a.textContent || '').trim().slice(0, 60);
    if (!label) return;
    if (!a.getAttribute('data-afs7-cta') && !a.closest('.afs7')) return;
    emit('afs7_cta_click', { label: label, href: a.getAttribute('href') || '' });
  }, true);

  var sent = false;
  function bye() {
    if (sent) return;
    sent = true;
    emit('afs7_exit', {
      max_percent: maxPct,
      seconds: Math.round((Date.now() - start) / 1000),
      last_section: lastSection,
      sections_seen: Object.keys(seen).length,
      bounced: (maxPct < 25 && (Date.now() - start) < 10000) ? 1 : 0
    });
  }
  window.addEventListener('pagehide', bye);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') bye();
  });
})();